/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var STORE_HISTORY_TYPE;
(function (STORE_HISTORY_TYPE) {
    STORE_HISTORY_TYPE["LOST_SALES"] = "lost_sales";
    STORE_HISTORY_TYPE["SALES_SAVED"] = "sales_saved";
    STORE_HISTORY_TYPE["AVG_DOWNTIME"] = "avg_downtime";
})(STORE_HISTORY_TYPE || (STORE_HISTORY_TYPE = {}));
